<script setup>
import {
    getCurrentInstance,
    ref
} from 'vue'
import {
    useRouter
} from 'vue-router'

const {
    proxy
} = getCurrentInstance()
const router = useRouter()
const email = ref('')
const message = ref('')
const showMessage = ref(false)

async function resendActivation() {
    if (!email.value) {
        message.value = "Please enter your email address."
        showMessage.value = true
        return
    }
    
    try {
        const res = await proxy.$api({
            "serviceName": "session",
            "methodName": "resendActivation",
            "parameters": [email.value]
        })
        message.value = res
        showMessage.value = true
    } catch (error) {
        message.value = "An error occurred while sending the activation email. Please try again."
        showMessage.value = true
    }
}
</script>

<template>
    <div class="d-flex justify-center align-center" style="height: 100vh;">
        <v-card width="500px" variant="tonal" style="padding: 20px;">
            <v-card-title class="text-center mb-4">
                <v-icon class="mr-2">mdi-email-send</v-icon>
                Resend Activation Email
            </v-card-title>
            
            <v-alert v-if="showMessage" class="mb-4 d-flex justify-center" :text="message" type="info"></v-alert>
            
            <v-card-text>
                <p class="text-center mb-4">
                    Enter your email address to receive a new activation link if your account is not yet activated.
                </p>
                
                <v-text-field 
                    prepend-icon="mdi-email" 
                    v-model="email" 
                    label="Email Address"
                    variant="outlined"
                    class="mb-4"
                ></v-text-field>
                
                <div class="d-flex justify-center gap-4">
                    <v-btn 
                        variant="flat" 
                        color="primary" 
                        @click="resendActivation"
                        style="width: 200px;"
                    >
                        Send Activation Email
                    </v-btn>
                    
                    <v-btn 
                        variant="outlined" 
                        @click="router.push('/')"
                        style="width: 100px;"
                    >
                        Back to Home
                    </v-btn>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<style scoped>
.gap-4 {
    gap: 1rem;
}

button:hover {
    background: #1976d2b8!important;
}
</style>
